// Gestione classe 'webview' sul body
// La classe viene aggiunta principalmente dallo script inline in theme.liquid (prima del paint)
// Questo script è un fallback e gestisce il log

const ua = navigator.userAgent.toLowerCase();
const is_webview = ua.includes('mumble-app') || ua.includes('shoppy');
console.log('is_webview', ua, is_webview);

if(is_webview && !document.body.classList.contains('webview')) {
  document.body.classList.add('webview');
}